import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppFloat from '../../components/feature/WhatsAppFloat';
import WhatsAppSelector from '../../components/feature/WhatsAppSelector';
import { useState } from 'react';

export default function Products() {
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('');

  const handleCotizar = (productName: string) => {
    setSelectedProduct(productName);
    setWhatsappOpen(true);
  };

  const products = [
    {
      name: 'Diseño y Creación de Páginas Web',
      description: 'Sitios web profesionales y modernos para impulsar tu presencia digital',
      image: 'https://readdy.ai/api/search-image?query=Modern%20web%20design%20and%20development%2C%20professional%20website%20creation%2C%20responsive%20web%20design%2C%20digital%20agency%20services%2C%20clean%20interface%20design%2C%20computer%20screen%20showing%20website%2C%20modern%20workspace%2C%20web%20development%20tools%2C%20creative%20design%20process&width=400&height=300&seq=web-design-products&orientation=landscape',
    },
    {
      name: 'Pendones',
      description: 'Pendones publicitarios de alta calidad para promocionar tu marca',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/1ec92307be7105b7829e3df564de7b8b.jpeg',
    },
    {
      name: 'Avisos',
      description: 'Señalización comercial y avisos publicitarios para tu negocio',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/32e2b37e1b248369a09c09c62a1acd92.png',
    },
    {
      name: 'Rompetráficos',
      description: 'Displays llamativos para captar la atención en puntos estratégicos',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/fb0d1e97e7df4feacaf277ebaad08f7a.png',
    },
    {
      name: 'Microperforado',
      description:
        'Vinilo microperforado para ventanas con visibilidad desde el interior',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/bae081366725d284baef60eddc880915.png',
    },
    {
      name: 'Stickers',
      description: 'Adhesivos personalizados para cualquier superficie y uso promocional',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/6ab98c0178e5bcae05cfc45ef6a49fdc.png',
    },
    {
      name: 'Stickers con Corte (Semicorte)',
      description: 'Stickers con corte especial para fácil desprendimiento y aplicación',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/7ce1ae663db304cdb292e01add203413.png',
    },
    {
      name: 'Volantes',
      description:
        'Material promocional efectivo para distribución masiva de tu mensaje',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/ce9990c79ddec5f077c1d7ff67c7b202.jpeg',
    },
    {
      name: 'Folletos',
      description:
        'Información detallada de tus productos y servicios en formato atractivo',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20brochures%20and%20pamphlets%2C%20tri-fold%20marketing%20materials%2C%20corporate%20information%20booklets%2C%20high%20quality%20printing%2C%20business%20promotional%20literature%2C%20elegant%20design%2C%20white%20background&width=400&height=300&seq=folletos&orientation=landscape',
    },
    {
      name: 'Tarjetas de Presentación',
      description: 'Tu primera impresión cuenta, diseños únicos y profesionales',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/2a4a1c62c7f15eadcf9f86651aabc772.png',
    },
    {
      name: 'Cuadernos',
      description: 'Cuadernos personalizados, útiles promocionales que perduran',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/5354a0199fbe79d3ff1d4a159886713a.png',
    },
    {
      name: 'Cajas Personalizadas (Empaques)',
      description: 'Empaques personalizados que protegen y promocionan tu producto',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/a3cfd27e5878ca4afda31b04c4ec247a.png',
    },
    {
      name: 'Bolsas Personalizadas (Empaques)',
      description: 'Bolsas promocionales que llevan tu marca a todas partes',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/f4cba12b44430755e9d877080c48df42.png',
    },
    {
      name: 'Retablos Publicitarios',
      description: 'Retablos decorativos en MDF, impresos en alta calidad, ideales para darle personalidad y estilo a hogares, oficinas y negocios.',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/6f7fd918a8fcf5be71dd94c6ae1226e0.png',
    },
    {
      name: 'Botones Publicitarios',
      description: 'Botones promocionales personalizados para eventos y campañas',
      image:
        'https://readdy.ai/api/search-image?query=Custom%20promotional%20buttons%20and%20badges%2C%20advertising%20pins%2C%20campaign%20buttons%2C%20personalized%20button%20printing%2C%20colorful%20promotional%20items%2C%20event%20merchandise%2C%20white%20background&width=400&height=300&seq=botones&orientation=landscape',
    },
    {
      name: 'Escarapelas y Carnés',
      description: 'Identificación profesional y escarapelas para eventos corporativos',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20ID%20cards%20and%20badges%2C%20corporate%20identification%2C%20event%20badges%2C%20employee%20ID%20cards%2C%20security%20badges%2C%20professional%20card%20printing%2C%20clean%20design%2C%20white%20background&width=400&height=300&seq=escarapelas-carnes&orientation=landscape',
    },
    {
      name: 'Factureros (Talonarios de Facturas)',
      description: 'Talonarios de facturas numerados para control contable',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/b66ecf9afea4efbb8c124b0a5176523b.png',
    },
    {
      name: 'Abanicos Publicitarios',
      description: 'Abanicos promocionales únicos para eventos y campañas de verano',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/c2e10058995decf842670213b8a1ab56.png',
    },
    {
      name: 'Mugs Personalizados',
      description: 'Tazas personalizadas, regalo corporativo perfecto y duradero',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/58d04db892dc8241d9ac1e8620a4091f.png',
    },
    {
      name: 'Buzos Personalizados',
      description: 'Buzos y sudaderas personalizadas con tu diseño único',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/a0ff62c6118092369f5d7070eafddf69.jpeg',
    },
    {
      name: 'Camisetas Personalizadas',
      description: 'Camisetas impresas de alta calidad con diseños únicos',
      image:
        'https://readdy.ai/api/search-image?query=Custom%20printed%20t-shirts%20with%20vibrant%20designs%2C%20personalized%20apparel%2C%20textile%20printing%2C%20branded%20clothing%2C%20high%20quality%20fabric%20printing%2C%20colorful%20graphic%20tees%2C%20white%20background&width=400&height=300&seq=camisetas&orientation=landscape',
    },
    {
      name: 'Gorras Personalizadas',
      description: 'Gorras bordadas y estampadas con tu logo y diseño',
      image:
        'https://readdy.ai/api/search-image?query=Custom%20embroidered%20caps%20and%20hats%2C%20personalized%20headwear%2C%20branded%20caps%2C%20promotional%20hats%2C%20high%20quality%20cap%20printing%20and%20embroidery%2C%20corporate%20merchandise%2C%20white%20background&width=400&height=300&seq=gorras&orientation=landscape',
    },
    {
      name: 'Material P.O.P.',
      description:
        'Material punto de venta para exhibiciones promocionales efectivas',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/797357acba6fb2a2d3090e2fd2d2c783.png',
    },
    {
      name: 'Manillas VIP',
      description: 'Pulseras de identificación VIP para eventos exclusivos',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/8c0bcd6f87ce52e9b73a18e6edbb51e3.png',
    },
    {
      name: 'Pines Metálicos y en Resina (Resinados)',
      description: 'Pines personalizados de alta calidad en metal y resina',
      image:
        'https://readdy.ai/api/search-image?query=Custom%20metal%20pins%20and%20resin%20badges%2C%20enamel%20pins%2C%20promotional%20lapel%20pins%2C%20corporate%20pins%2C%20high%20quality%20pin%20manufacturing%2C%20collectible%20pins%2C%20professional%20pin%20design%2C%20white%20background&width=400&height=300&seq=pines-metalicos&orientation=landscape',
    },
    {
      name: 'Sellos',
      description: 'Sellos personalizados para documentos y papelería comercial',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/c414365ada2de2966abb5c586eeb659a.jpeg',
    },
    {
      name: 'Papel de Envoltura',
      description: 'Papel decorativo personalizado para empaques y regalos especiales',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/2912bfdb53192e389af09ca4f616fac1.jpeg',
    },
    {
      name: 'Roll-Up',
      description: 'Displays portátiles enrollables para presentaciones y eventos',
      image:
        'https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/06ac7a7316c663a5e9032fc946e663d6.png',
    },
  ];

  // Manejo de error de carga de imágenes: usar una imagen por defecto si falla
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = '/placeholder.png';
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section
          className="py-20 relative"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20printing%20products%20showcase%2C%20various%20printed%20materials%20display%2C%20banners%20posters%20flyers%20business%20cards%2C%20commercial%20printing%20samples%2C%20colorful%20marketing%20materials%2C%20modern%20printing%20technology%2C%20clean%20organized%20presentation&width=1920&height=600&seq=products-hero&orientation=landscape')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-black/50"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Productos y Servicios
            </h1>
            <p className="text-xl text-gray-200 max-w-3xl mx-auto">
              Tu marca merece verse brutal, y nosotros lo hacemos realidad.
            </p>
          </div>
        </section>

        {/* Products Grid */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {products.map((product, productIndex) => (
                <div
                  key={productIndex}
                  className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group border border-gray-100 relative overflow-visible"
                  data-product-shop
                >
                  <div className="h-48 overflow-visible bg-gray-100 relative rounded-t-xl">
                    <img
                      src={product.image}
                      alt={product.name}
                      onError={handleImageError}
                      className="w-full h-full object-cover object-top rounded-t-xl transition-all duration-500 ease-out group-hover:scale-125 group-hover:z-50 group-hover:shadow-2xl group-hover:rounded-lg relative"
                      style={{
                        transformOrigin: 'center center'
                      }}
                    />
                  </div>
                  <div className="p-5">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
                      {product.name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                      {product.description}
                    </p>
                    <div className="flex gap-2">
                      <button 
                        onClick={() => handleCotizar(product.name)}
                        className="w-full bg-teal-600 hover:bg-teal-700 text-white py-2 px-4 rounded-lg transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer text-center"
                      >
                        Cotizar
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Custom Services */}
        <section className="py-20 bg-teal-600">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              ¿Necesitas Algo Personalizado?
            </h2>
            <p className="text-xl text-teal-100 mb-8 max-w-3xl mx-auto">
              Nuestro equipo transforma ideas en impacto. Diseños potentes, impresiones que destacan y resultados que marcan la diferencia.
            </p>
            <div className="flex justify-center">
              <a
                href="https://wa.me/573209769166"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200 flex items-center justify-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill mr-2"></i>
                Hablar con un Experto
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloat />
      <WhatsAppSelector 
        isOpen={whatsappOpen} 
        onClose={() => setWhatsappOpen(false)} 
        productName={selectedProduct}
      />
    </div>
  );
}
